import { Form, InputNumber, Switch } from 'antd';
import { useTranslation } from '../../../i18n/i18n';
import React from 'react';
import './FormBuildingData.scss';

export type InstallationLocationBuildingFormValues = {
  numberOfApartments?: number;
  numberOfFloors?: number;
  numberOfCommercialUnits?: number;
  buildingAreaM2?: number;
  averageAge?: number;
  numberOfPeople?: number;
  roofAreaM2?: number;
  hasRainwaterHarvesting?: boolean;
};

const MIN = 0;

const FormBuildingData = () => {
  const { t } = useTranslation('installation-location', { keyPrefix: 'installationLocationDetail' });

  return (
    <>
      <Form.Item name="numberOfFloors" label={t('floorsNum')}>
        <InputNumber className={'InputArea'} min={MIN} />
      </Form.Item>
      <Form.Item name="numberOfApartments" label={t('flatNum')}>
        <InputNumber className={'InputArea'} min={MIN} />
      </Form.Item>
      <Form.Item name="numberOfCommercialUnits" label={t('locals')}>
        <InputNumber className={'InputArea'} min={MIN} />
      </Form.Item>
      <Form.Item name="buildingAreaM2" label={`${t('squaredMeters')} (${t('metersSquared')})`}>
        <InputNumber className={'InputArea'} min={MIN} />
      </Form.Item>
      <Form.Item name="averageAge" label={`${t('avgAge')} (${t('years')})`}>
        <InputNumber className={'InputArea'} min={MIN} />
      </Form.Item>
      <Form.Item name="numberOfPeople" label={t('numPeople')}>
        <InputNumber className={'InputArea'} min={MIN} />
      </Form.Item>
      <Form.Item name="roofAreaM2" label={`${t('squaredMetersRoof')} (${t('metersSquared')})`}>
        <InputNumber className={'InputArea'} min={MIN} />
      </Form.Item>
      <div className={'SwitchArea'}>
        <span>{t('riverCollecting')}</span>
        <Form.Item name="hasRainwaterHarvesting" valuePropName="checked" noStyle>
          <Switch />
        </Form.Item>
      </div>
    </>
  );
};

export default FormBuildingData;
